import React from 'react';
import { SubmitHandler } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Box } from '@mui/material';

import { SignInForm } from 'src/features/auth/components/SignInForm';
import { ILoginCredentials } from 'src/features/auth/domain/types';
import { AuthService } from 'src/features/auth/infrastructure/authService';
import { AppDispatch } from 'src/store';

export const SignInPage: React.FC = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch<AppDispatch>();
	const authService = new AuthService(dispatch);

	const handleSubmit: SubmitHandler<ILoginCredentials> = async (data) => {
		const success = await authService.handleLogin(data);
		if (success) {
			navigate('/dashboard', { replace: true });
		}
	};

	return (
		<Box sx={{ backgroundColor: '#F9F9F9', minHeight: '100vh' }}>
			<SignInForm onSubmit={handleSubmit} />
		</Box>
	);
};
